import { textSm } from '@insify/design-system/typography';
import clsx from 'clsx';

import { separator } from './Separator.module.css';

type Props = {
  className?: string;
  children: React.ReactNode;
};

export const Separator: React.FC<Props> = ({ children, className }) => {
  return <div className={clsx(className, textSm, separator)}>{children}</div>;
};
